export class Const {
  /** 管制画面種類. */
  static readonly ControlPageType = {
    /** 管制画面(FMS). */
    FMS_PAGE: 'FmsPage',
    /** 管制画面(CMS). */
    CMS_PAGE: 'CmsPage',
    /** 管制画面(地図全体). */
    MAP_PAGE: 'MapPage',
    /** 管制画面(需要管理). */
    DEMAND_PAGE: 'RestPlanPage',
    /** 管制画面(事前予約). */
    RESERVE_PAGE: 'AdvanceReservePage',
  };

  /** 画面項目の種類. */
  static readonly Field = {
    /** ユーザオプション. */
    USER_OPTION: 'userOption',
    /** 車両オプション. */
    VEHICLE_OPTION: 'vehicleOption'
  };

  /** 最大桁数. */
  static readonly MaxLength = {
    /** 19桁(BigInteger最大桁数). */
    MAX_LENGTH_19: 19
  };

  /** コントロールタイプ. */
  static readonly ControlType = {
    /** テキストボックス. */
    TEXT_BOX: 'textbox',
    /** プルダウン. */
    DROP_DOWN: 'dropdown',
    /** プルダウン（複数）. */
    MULTIPLE_DROP_DOWN: 'multiple_dropdown',
    /** トグルボタン. */
    TOGGLE_BUTTON: 'togglebutton'
  };

  /** バリデーションパターン（正規表現） */
  static readonly ValidatorsPattern = {
    /** 数値のみ. 空文字の場合、正規表現はチェックしない. */
    NUMERIC : {
      pattern: /^$|^[0-9.]*$/,
      message: '半角数字で入力してください。'
    },
    /** 半角英数字のみ(大文字小文字可能). 空文字の場合、正規表現はチェックしない. */
    HALF_WIDTH_ALPHANUMERIC : {
      pattern: /^$|^[a-zA-Z0-9]*$/,
      message: '半角英数字で入力してください。'
    },
    /** 半角英数字カンマのみ(大文字小文字可能). 空文字の場合、正規表現はチェックしない. */
    HALF_WIDTH_ALPHANUMERIC_COMMA : {
      pattern: /^$|^[a-zA-Z0-9,]*$/,
      message: '半角英数字とカンマで入力してください。'
    },
    /** 緯度. 空文字の場合、正規表現はチェックしない. */
    LAT : {
      pattern: /^$|^-?(90(\.0{1,9})?|[1-8]?[0-9](\.[0-9]{1,9})?)$/,
      message: '緯度（-90～90）を入力してください。'
    },
    /** 経度. 空文字の場合、正規表現はチェックしない. */
    LON : {
      pattern: /^$|^-?(180(\.0{1,9})?|1[0-7][0-9](\.[0-9]{1,9})?|[1-9]?[0-9](\.[0-9]{1,9})?)$/,
      message: '経度（-180～180）を入力してください。'
    },
    /** 需要計算間隔. 空文字の場合、正規表現はチェックしない. */
    WAIT_POINT_PLAN_DEMAND_CALC_INTERVAL : {
      pattern: /^$|^([1-9]|[1-9][0-9]|[1-9][0-9][0-9]|1[0-3][0-9][0-9]|14[0-3][0-9])$/,
      message: '1～1439 を入力してください。'
    },
    /** 再配置閾値. 空文字の場合、正規表現はチェックしない. */
    WAIT_POINT_PLAN_RELOCATION_THRESHOLD : {
      pattern: /^$|^[0-9]{1,5}$/,
      message: '0～99999 を入力してください。'
    },
    /** バッチ実行間隔. 空文字の場合、正規表現はチェックしない. */
    EXEC_INTERVAL : {
      pattern: /^$|^([1-9]|[1-9][0-9]|[1-9][0-9][0-9]|[1-9][0-9][0-9][0-9]|[1-7][0-9][0-9][0-9][0-9]|8[0-5][0-9][0-9][0-9]|86[0-3][0-9][0-9]|86400)$/,
      message: '1～86400 を入力してください。'
    },
    /** HH:mm. 空文字の場合、正規表現はチェックしない. */
    HH_COLON_MM : {
      pattern: /^$|^([0-1][0-9]|2[0-3]):[0-5][0-9]$/,
      message: 'HH:mm 形式で入力してください。'
    },
    /** H:mm. 空文字の場合、正規表現はチェックしない. */
    H_COLON_MM : {
      pattern: /^$|^([0-9]|[0-9][0-9]):[0-5][0-9]$/,
      message: 'H:mm形式で入力してください。'
    },
    /** 分. 空文字の場合、正規表現はチェックしない. */
    MINUTES : {
      pattern: /^$|^[0-9]*$/,
      message: '半角数字で入力してください。'
    },
    /** 百分率. 空文字の場合、正規表現はチェックしない. */
    PERCENTAGE : {
      pattern: /^$|^([0-9]|[0-9][0-9]|100)$/,
      message: '1～100 を入力してください。'
    },
    /** 件数. 空文字の場合、正規表現はチェックしない. */
    NUMBER : {
      pattern: /^$|^[0-9]*$/,
      message: '半角数字で入力してください。'
    },
    /** 分類番号. 空文字の場合、正規表現はチェックしない. */
    CLASSIFICATION_NUMBER : {
      pattern: /^[A-Z0-9]{0,3}$/,
      message: '半角大文字英字または数字を入力してください。'
    },
    /** 判別文字. 空文字の場合、正規表現はチェックしない. */
    IDENTIFICATION_CHAR : {
      pattern: /^$|^[あ-ん]|[Ａ-Ｚ]$/,
      message: '全角文字を入力してください。'
    },
  }

  /** レスポンスの結果種類 */
  static readonly ResponseResult = {
    /** 0:失敗. */
    FAIL : 0,
    /** 1:成功. */
    SUCCESS : 1,
  }

  /** インフォメーション. */
  static readonly Info = {
    /** 入力エラー. */
    VALID_ERROR: '入力に不備があります。入力内容を確認してください。',

    /** 登録成功. */
    ENTRY_SUCCESS: '登録しました。',
    /** 登録失敗. */
    ENTRY_ERROR: '登録に失敗しました。',

    /** 保存成功. */
    SAVE_SUCCESS: '保存しました。',
    /** 保存失敗. */
    SAVE_ERROR: '保存に失敗しました。',

    /** 削除成功. */
    DELETE_SUCCESS: '削除しました。',
    /** 削除失敗. */
    DELETE_ERROR: '削除に失敗しました。',

    /** 顔認証登録成功. */
    FACE_REGIST_SUCCESS: '顔認証登録しました。',
    /** 顔認証登録失敗. */
    FACE_REGIST_ERROR: '顔認証登録に失敗しました。',

    /** 顔認証登録解除成功. */
    FACE_RELEASE_SUCCESS: '顔認証登録解除しました。',
    /** 顔認証登録解除失敗. */
    FACE_RELEASE_ERROR: '顔認証登録解除に失敗しました。',

    /** ファイルサイズ超過. */
    FILE_SIZE_ERROR: 'ファイルサイズが超過しています。',
    /** ファイル種類エラー. */
    FILE_UNMATCH_EXTENSION: '指定の拡張子以外のファイルが選択されています。',

    /** ファイルアップロード成功. */
    FILE_UPLOAD_SUCCESS: 'ファイルをアップロードしました。',
    /** ファイルアップロード失敗. */
    FILE_UPLOAD_ERROR: 'ファイルのアップロードに失敗しました。'
  };
}



// WEBPACK FOOTER //
// ./src/providers/const.ts